import React from 'react';
import useSession from '../Util/useSession';
import { CircularProgress } from '@material-ui/core';
import PitchSessionVideo from './PitchSessionVideo';

interface Props {
  session?: string;
  pitch: string;
}

const PitchSessionVideos: React.FunctionComponent<Props> = ({ session, pitch }) => {
  const { session: data } = useSession(session);
  if (data) {
    const ret = data.videos
      .slice()
      .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
      .map((video) => <PitchSessionVideo key={video.id} pitch={pitch} video={String(video.id)} />);
    return <div className="sciui-grid sciui-m-y-l">{ret}</div>;
  }
  return <CircularProgress />;
};

export default PitchSessionVideos;
